export function showModal(modalId) {
    const modalElement = document.getElementById(modalId);
    if (!modalElement)
        return;
    const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
    modal.show();
}
export function hideModal(modalId) {
    const modalElement = document.getElementById(modalId);
    if (!modalElement)
        return;
    const modal = bootstrap.Modal.getInstance(modalElement);
    modal === null || modal === void 0 ? void 0 : modal.hide();
}
